"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _SimpleDate = require("UIComponents/core/SimpleDate");

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _CRMDateInput = _interopRequireDefault(require("crm_ui/date/CRMDateInput"));

var PureRenderMixin = _react.default.addons.PureRenderMixin;
var DateCategoryInput = (0, _createReactClass.default)({
  displayName: 'DateCategoryInput',
  mixins: [PureRenderMixin, _ComponentWithPartials.default],
  propTypes: {
    className: _propTypes.default.string,
    selectedCategory: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.object]),
    categories: _propTypes.default.array.isRequired,
    onCategorySelect: _propTypes.default.func.isRequired,
    includeCustomDate: _propTypes.default.bool,
    minimumDateValue: _propTypes.default.object
  },
  getDefaultProps: function getDefaultProps() {
    return {
      includeCustomDate: true,
      minimumDateValue: _I18n.default.moment.userTz()
    };
  },
  onCustomDateChange: function onCustomDateChange(_ref) {
    var value = _ref.target.value;
    this.props.onCategorySelect(value);
  },
  renderCustomDateOption: function renderCustomDateOption() {
    if (!this.props.includeCustomDate) {
      return null;
    }

    return _react.default.createElement(_UIButton.default, {
      use: "link",
      onClick: this.partial(this.props.onCategorySelect, 'custom'),
      "data-selenium-test": "follow-up-task-dropdown-option-custom-date"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "dateCategoryInput.customDateLabel"
    }));
  },
  renderCategories: function renderCategories() {
    var _this = this;

    var _this$props = this.props,
        categories = _this$props.categories,
        onCategorySelect = _this$props.onCategorySelect;
    return categories.map(function (category) {
      return _react.default.createElement(_UIButton.default, {
        use: "link",
        key: category.value,
        onClick: _this.partial(onCategorySelect, category),
        "data-selenium-test": "follow-up-task-dropdown-option-" + category.value
      }, category.text);
    });
  },
  renderCustomDate: function renderCustomDate() {
    var _this$props2 = this.props,
        selectedCategory = _this$props2.selectedCategory,
        minimumDateValue = _this$props2.minimumDateValue;

    var focusInput = function focusInput(ref) {
      return ref && ref.focus();
    };

    return _react.default.createElement("div", {
      className: "display-inline-block"
    }, _react.default.createElement(_CRMDateInput.default, {
      className: "p-left-1",
      name: "value",
      onChange: this.onCustomDateChange,
      value: selectedCategory,
      minValue: (0, _SimpleDate.fromMoment)(minimumDateValue),
      size: "small",
      ref: focusInput,
      "data-selenium-test": "follow-up-task-date-category-custom-date"
    }));
  },
  render: function render() {
    var _this$props3 = this.props,
        selectedCategory = _this$props3.selectedCategory,
        className = _this$props3.className;

    if (typeof selectedCategory === 'number') {
      return this.renderCustomDate();
    }

    return _react.default.createElement("span", {
      className: className,
      "data-selenium-test": "follow-up-task-date-category-input"
    }, _react.default.createElement(_UIDropdown.default, {
      buttonUse: "link",
      menuWidth: "auto",
      buttonText: selectedCategory.text
    }, _react.default.createElement(_UIList.default, null, this.renderCategories(), this.renderCustomDateOption())));
  }
});
var _default = DateCategoryInput;
exports.default = _default;
module.exports = exports.default;